// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import type { FileDownloadProps } from '@dip/helsecore/src/components/parts/FileDownload/FileDownload.d';
import { FileDownload } from '@dip/helsecore/src/components/parts/FileDownload/FileDownload';

export default function HelsecoreFileDownload(props: Readonly<FileDownloadProps>) {
  return <FileDownload {...props} />;
}
